import React from 'react';

import { useLanguage } from '../i18n';

const layout = [
  'aspect-[16/10] lg:col-span-2 lg:aspect-auto',
  'aspect-[4/3] lg:col-start-1 lg:row-start-2 lg:aspect-auto',
  'aspect-[3/4] lg:col-start-3 lg:row-span-2 lg:row-start-1 lg:aspect-auto',
];

const Poster = ({ poster, className }) => (
  <figure className={`relative grid items-end overflow-hidden rounded-card bg-sky ${className}`}>
    <img
      src={poster.image}
      alt={poster.alt}
      loading='lazy'
      className='absolute inset-0 h-full w-full object-cover'
    />
    <div
      className='absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black/70'
      aria-hidden='true'
    />
    <figcaption className='relative p-6 text-white sm:p-8'>
      <p className='font-display text-[26px] font-semibold leading-tight tracking-title sm:text-[30px]'>
        {poster.title}
      </p>
      <p className='mt-2 max-w-[340px] text-white/85'>{poster.text}</p>
    </figcaption>
  </figure>
);

const Posters = () => {
  const { posters, postersSection } = useLanguage().t;

  return (
    <section className='pb-20 lg:pb-28'>
      <div className='container'>
        <div className='max-w-[620px]'>
          <p className='eyebrow'>{postersSection.eyebrow}</p>
          <h2 className='title mt-4'>{postersSection.title}</h2>
        </div>

        <div className='mt-12 grid gap-4 lg:h-[760px] lg:grid-cols-3 lg:grid-rows-2'>
          <Poster poster={posters[0]} className={layout[0]} />
          <Poster poster={posters[1]} className={layout[1]} />
          <div
            data-nav-on='dark'
            className='flex flex-col justify-between rounded-card bg-ronda p-8 text-canvas lg:col-start-2 lg:row-start-2'
          >
            <span className='flex gap-1.5' aria-hidden='true'>
              <span className='h-2 w-8 rounded-full bg-ronda-mint' />
              <span className='h-2 w-4 rounded-full bg-ronda-mint/60' />
            </span>
            <div className='mt-16 lg:mt-0'>
              <p className='font-display text-[30px] font-semibold leading-tight tracking-title text-canvas'>
                {postersSection.featureTitle}
              </p>
              <p className='mt-3 leading-relaxed text-canvas/80'>{postersSection.featureText}</p>
            </div>
          </div>
          <Poster poster={posters[2]} className={layout[2]} />
        </div>
      </div>
    </section>
  );
};

export default Posters;
